import React, { useEffect, useRef } from "react";
import { isEmpty } from "lodash";
import Slider from "react-slick";

import { Box, FlexContainer, FlexDiv } from "@/components/Atoms/Box";
import { Typography } from "@/foundation/Typography/V1";
import Button from "@/components/Atoms/Button";
import theme from "@/foundation/Theme";

import { CardBody, Heading, LI, SlideWrap, TopBox, UL } from "./style";

const CardComponent = (props) => {
  const {
    cardRef,
    openPaymentPage = () => {},
    isCorporatePage,
    isOldUserReactivationPage,
  } = props || {};
  const slider = useRef(null);
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: `${props?.planData?.length || 4}.15`,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: `${props?.planData?.length || 4}.15`,
          dots: true,
          infinite: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.15,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
        },
      },
    ],
  };
  useEffect(() => {
    let sliders = slider;
    setTimeout(() => {
      if (sliders.current) {
        sliders.current.slickGoTo(0);
      }
    }, 2000);
  }, []);
  return (
    <FlexDiv py={"40px"} flexDirection="column" ref={cardRef}>
      <FlexContainer flexDirection="column" alignItems={"center"}>
        {props?.planData?.length > 0 && (
          <Heading
            textAlign={"center"}
            variant="heading2"
            color={theme.colors.link2Color}
          >
            {isCorporatePage || isOldUserReactivationPage
              ? "Our packages"
              : "All packages"}
          </Heading>
        )}
        <FlexDiv width={"100%"} flexDirection="column">
          <SlideWrap mx={"-10px"}>
            <Slider ref={slider} {...settings}>
              {!isEmpty(props?.planData) &&
                props?.planData?.map((item, index) => {
                  return (
                    <CardBody
                      flexDirection={"column"}
                      alignItems={"flex-start"}
                      key={index}
                    >
                      <TopBox>
                        <Box>
                          <Typography
                            variant={"title1"}
                            color={theme.colors.white}
                          >
                            {item?.title}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            variant={"title1"}
                            color={theme.colors.white}
                          >
                            {item?.price_text}
                          </Typography>
                        </Box>
                      </TopBox>
                      <UL>
                        {item?.feature_list.map((list, i) => {
                          const text = { __html: list };
                          let string = list;
                          let substring = 'class="gold"';
                          return (
                            <LI
                              key={i}
                              disablebullet={string.includes(substring)}
                            >
                              <Typography
                                variant="paragraph2"
                                color={theme.colors.white}
                                dangerouslySetInnerHTML={text}
                              />
                            </LI>
                          );
                        })}
                      </UL>

                      {item?.button_cta && (
                        <Button
                          variant={"primary1"}
                          bgColor={theme.colors.white}
                          hoverColor={theme.colors.white}
                          TextColor={theme.colors.gray_100}
                          onClick={() => openPaymentPage(item)}
                          fontSize={"11px"}
                          fontFamily={"var(--font-700)"}
                          btnPadding={"3.4px 24px"}
                          mt={"15px"}
                        >
                          {item?.button_cta}
                        </Button>
                      )}
                    </CardBody>
                  );
                })}
            </Slider>
          </SlideWrap>
        </FlexDiv>
      </FlexContainer>
    </FlexDiv>
  );
};
export default CardComponent;
